import each from 'lodash-es/each';
import filter from 'lodash-es/filter';
import find from 'lodash-es/find';
import forOwn from 'lodash-es/forOwn';
import findIndex from 'lodash-es/findIndex';
import isArray from 'lodash-es/isArray';
import flatten from 'lodash-es/flatten';
import zip from 'lodash-es/zip';
import map from 'lodash-es/map';
import merge from 'lodash-es/merge';
import isEmpty from 'lodash-es/isEmpty';
import sortBy from 'lodash-es/sortBy';
import groupBy from 'lodash-es/groupBy';
import size from 'lodash-es/size';
import fromPairs from 'lodash-es/fromPairs';
import isEqual from 'lodash-es/isEqual';
import sum from 'lodash-es/sum';
import sumBy from 'lodash-es/sumBy';
import includes from 'lodash-es/includes';
import uniq from 'lodash-es/uniq';
import uniqBy from 'lodash-es/uniqBy';
import range from 'lodash-es/range';
import isFunction from 'lodash-es/isFunction';
import isString from 'lodash-es/isString';
import isSet from 'lodash-es/isSet';
import isBoolean from 'lodash-es/isBoolean';
import isNumber from 'lodash-es/isNumber';
import isInteger from 'lodash-es/isInteger';
import isDate from 'lodash-es/isDate';
import isNil from 'lodash-es/isNil';
import identity from 'lodash-es/identity';
import countBy from 'lodash-es/countBy';
import without from 'lodash-es/without';
import pickBy from 'lodash-es/pickBy';
import padEnd from 'lodash-es/padEnd';
// isPlainObject is like python isinstance(e, dict) - that's what's useful
//~ import isObject from 'lodash-es/isObject'
import isPlainObject from 'lodash-es/isPlainObject';
// maybe rename to isDict
const isObject = isPlainObject;
// set methods
import intersection from 'lodash-es/intersection';
import difference from 'lodash-es/difference';
import noop from 'lodash-es/noop';
import orderBy from 'lodash-es/orderBy';
import clone from 'lodash-es/clone';
import cloneDeep from 'lodash-es/cloneDeep';
import has from 'lodash-es/has';
import get from 'lodash-es/get';
const isFloat = (n)=>n === +n && n !== (n | 0);
/**
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/shallowEqual.js
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ const shallowEqual = (objA, objB)=>{
    if (Object.is(objA, objB)) {
        return true;
    }
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
};
// shallow compare of arrays
const isArrayEqual = (a1, a2)=>a1.length === a2.length && a1.every((e, i)=>Object.is(e, a2[i]));
// python dict like interface
let dict = fromPairs;
//~ dict = Object.fromEntries
let iterItems = (object, f)=>each(entries(object), ([key, value])=>f(key, value));
// dict to list comprehension
let mapItems = (object, f, filterFunc)=>filterFunc ? entries(object).filter(([key, value])=>filterFunc(key, value)).map(([key, value], i)=>f(key, value, i)) : entries(object).map(([key, value], i)=>f(key, value, i));
let filterItems = (object, f)=>filter(entries(object), ([key, value])=>f(key, value));
// returns true if f matches for at least one tuple
let someItems = (object, f)=>entries(object).some(([key, value])=>f(key, value));
import keys from 'lodash-es/keys';
import values from 'lodash-es/values';
// https://github.com/tc39/proposal-object-values-entries
import entries from 'lodash-es/entries';
// this is python vocabulary
let items = entries;
let sorted = (l, key_or_opts, reverse)=>{
    /* if first element of l is a string (via key func) use strcmp
   */ let key = key_or_opts;
    let localcmp = true // is non-localcmp much faster?
    ;
    if (isObject(key_or_opts)) {
        key = key_or_opts.key;
        reverse = !!key_or_opts.reverse;
        // keep true default
        if (!isNil(key_or_opts.localcmp)) localcmp = !!key_or_opts.localcmp;
    }
    if (isObject(l)) {
        // as in python
        l = keys(l);
    } else if (isNil(l)) {
        console.log('sorted got a null/undefined input');
        l = [];
    }
    let r = reverse ? -1 : 1 // lets hope JIT optimizes * -1
    ;
    // default keys types are assumed to be numbers
    let cmp = (a, b)=>(a - b) * r;
    if (l.length > 0) {
        // determine type/shape of first key
        let key0 = null;
        if (!isNil(key)) {
            if (isString(key)) {
                // key is a attr name
                key0 = l[0][key];
            } else {
                // key is function
                key0 = key(l[0]);
            }
        } else {
            key0 = l[0];
        }
        let strcmp = localcmp ? (a, b)=>a.localeCompare(b) * r : (a, b)=>(a, b)=>((a > b) - (a < b)) * r;
        if (isString(key0)) {
            cmp = strcmp;
        } else if (isArray(key0)) {
            cmp = (a, b)=>{
                // compare each tuple
                for (let [left, right] of zip(a, b)){
                    if (left !== right) {
                        if (isString(left)) {
                            // assume two strings
                            return strcmp(left, right);
                        } else {
                            // assume number
                            return (left - right) * r;
                        }
                    }
                }
            };
        }
    }
    if (isNil(key)) {
        return [
            ...l
        ].sort((a, b)=>cmp(a, b));
    } else if (isString(key)) {
        // key is a attr name
        return [
            ...l
        ].sort((a, b)=>cmp(a[key], b[key]));
    } else {
        // key is function
        return [
            ...l
        ].sort((a, b)=>cmp(key(a), key(b)));
    }
};
// non mutating reverse
let reversed = (l)=>[
        ...l
    ].reverse();
// yes - does the right things (supports arbitrary chars)
import trim from 'lodash-es/trim';
import trimStart from 'lodash-es/trimStart';
import trimEnd from 'lodash-es/trimEnd';
let strip = trim;
let lstrip = trimStart;
let rstrip = trimEnd;
// get first item of list or null
let first = (l)=>l.length > 0 ? l[0] : null;
// like python str.isdigit, ok and we use camelCase here
let isDigit = (s)=>/^\d+$/.test(s);
// get
// has_key = has
// python enumerate() is array1.entries() or array.map((e, idx) => ...)
// https://www.rosettacode.org/wiki/Word_wrap#JavaScript
function wordwrap(text, width = 80, br = '\n', cut = false) {
    width >>>= 0;
    if (0 === width || text.length <= width) {
        return text;
    }
    return text.split('\n').map((line)=>{
        if (line.length <= width) {
            return line;
        }
        let words = line.split(' ');
        if (cut) {
            let temp = [];
            for (const word of words){
                if (word.length > width) {
                    let i = 0;
                    const length = word.length;
                    while(i < length){
                        temp.push(word.slice(i, Math.min(i + width, length)));
                        i += width;
                    }
                } else {
                    temp.push(word);
                }
            }
            words = temp;
        }
        let wrapped = words.shift();
        let spaceLeft = width - wrapped.length;
        for (const word of words){
            if (word.length + 1 > spaceLeft) {
                wrapped += br + word;
                spaceLeft = width - word.length;
            } else {
                wrapped += ' ' + word;
                spaceLeft -= 1 + word.length;
            }
        }
        return wrapped;
    }).join('\n');
}
function defaultdict(default_) {
    // XXX: not supported in IE 11 via babel!
    return new Proxy({}, {
        get: function(target, name, receiver) {
            // iterator and next are two JS1.7 things Firefox looks for when you
            // log an object to the console. pretty sure it's a bug that they trigger
            // the get trap.
            if (!(name in target) && !(name == '__iterator__' || name == 'next')) {
                target[name] = default_();
            }
            return target[name];
        }
    });
}
// https://stackoverflow.com/questions/27936772/how-to-deep-merge-instead-of-shallow-merge
// non mutating deep merge
let mergeDeep = (...objects)=>{
    /* if last param is true replace arrays instead of concat
   */ let replaceArrays = false;
    if (objects.at(-1) === true) {
        replaceArrays = true;
        objects = objects.slice(0, -1);
    }
    return objects.reduce((prev, obj)=>{
        Object.keys(obj).forEach((key)=>{
            const pVal = prev[key];
            const oVal = obj[key];
            if (replaceArrays && Array.isArray(pVal) && Array.isArray(oVal)) {
                prev[key] = pVal.concat(...oVal);
            } else if (isObject(pVal) && isObject(oVal)) {
                prev[key] = mergeDeep(pVal, oVal);
            } else {
                prev[key] = oVal;
            }
        });
        return prev;
    }, {});
};
// like https://github.com/smartprocure/futil-js#callorreturn
// If fn is a function, call the function with the passed-in arguments. Otherwise, return fn.
let callIfFunc = (fn, ...args)=>typeof fn === 'function' ? fn(...args) : fn;
export { isObject, isArray, isFunction, isString, isSet, isBoolean, isNumber, isInteger, isFloat, isDate, isNil, has, includes, each, filter, flatten, find, findIndex, forOwn, get, map, merge, mergeDeep, isEmpty, keys, values, items, entries, size, fromPairs, isEqual, shallowEqual, isArrayEqual, sum, sumBy, uniq, uniqBy, zip, clone, cloneDeep, noop, identity, // python stuff
dict, iterItems, mapItems, filterItems, someItems, defaultdict, range, sorted, reversed, strip, lstrip, rstrip, orderBy, first, isDigit, wordwrap, groupBy, difference, intersection, callIfFunc, countBy, without, pickBy, sortBy, padEnd,  };
